import { ParamIds, Places } from '../../../Constants'
import { MainKeys } from '../../../main/Main.keys'

export class AccessAuditKeys extends MainKeys {
    get place() {
        return Places.accessAudit
    }

    get start() {
        return this._intent.getParameterAsString(ParamIds.accessAuditStart)
    }

    set start(value: string | undefined) {
        this._intent.setParameter(ParamIds.accessAuditStart, value)
    }

    get end() {
        return this._intent.getParameterAsString(ParamIds.accessAuditEnd)
    }

    set end(value: string | undefined) {
        this._intent.setParameter(ParamIds.accessAuditEnd, value)
    }

    get groupId() {
        return this._intent.getParameterAsNumber(ParamIds.accessAuditGroup)
    }

    set groupId(value: number | undefined) {
        this._intent.setParameter(ParamIds.accessAuditGroup, value)
    }

    get userId() {
        return this._intent.getParameterAsNumber(ParamIds.accessAuditUser)
    }

    set userId(value: number | undefined) {
        this._intent.setParameter(ParamIds.accessAuditUser, value)
    }

    get placeCode() {
        return this._intent.getParameterAsString(ParamIds.accessAuditPage)
    }

    set placeCode(value: string | undefined) {
        this._intent.setParameter(ParamIds.accessAuditPage, value)
    }
}

export default AccessAuditKeys
